export const focusGlow = [
  // base
  'focus:outline-none',
  // border color
  'focus:border-primary',
  // glow effect
  'focus:shadow-glow',
];
